module.exports = __webpack_public_path__ + "static/img/active8.5d411730.png";